import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { EnrollInFormation, Formation } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface EnrolledFormationsState {
  enrolledFormations: Formation[];
  loading: boolean;
  userEnrolledFormations: EnrollInFormation[];
}

// Define the initial state using that type
const initialState: EnrolledFormationsState = {
  enrolledFormations: [],
  userEnrolledFormations: [],
  loading: false,
};

export const enrolledFormationsSlice = createSlice({
  name: "enrolledFormations",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setEnrolledFormations: (state, action: PayloadAction<Formation[]>) => {
      state.enrolledFormations = action.payload;
    },
    setUserEnrolledFormations: (
      state,
      action: PayloadAction<EnrollInFormation[]>
    ) => {
      state.userEnrolledFormations = action.payload;
    },
    setLoadingFormations: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setEnrolledFormations,
  setLoadingFormations,
  setUserEnrolledFormations,
} = enrolledFormationsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getEnrolledFormations = (state: RootState) =>
  state.enrolledFormations;
export default enrolledFormationsSlice.reducer;
